export default __webpack_public_path__ + "static/media/Version (1) - Hobbit_07.d23d2902.jpg";